<template>
    <div></div>
</template>

<script>
import { isUmebro } from '../../common/utils';

export default {
    computed: {
        isUmebro () {
            return isUmebro()
        },
    },
    created() {
        if (this.isUmebro) {
            window.location.replace('/login');
        } else {
            window.location.replace('home.html');
        }
    }
}
</script>